import React, { useEffect, useState } from 'react';
import axios from '../../utils/axiosWithAuth';


const SendAlerts = () => {
  const [users, setUsers] = useState([]);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [days, setDays] = useState(1);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');

  // ✅ Fetch subscribed users
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/admin/alert-users`);
        setUsers(res.data.users);
      } catch (error) {
        console.error('Failed to load users:', error);
      }
    };
    fetchUsers();
  }, []);

  // ✅ Handle checkbox selection
  const toggleEmail = (email) => {
    setSelectedEmails((prev) =>
      prev.includes(email)
        ? prev.filter((e) => e !== email)
        : [...prev, email]
    );
  };

  const selectAll = () => {
    setSelectedEmails(users.map((u) => u.email));
  };

  const clearAll = () => {
    setSelectedEmails([]);
  };

  // ✅ Fetch jobs from backend
  const loadJobs = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/jobs/recent?days=${days}`);
      setJobs(res.data.jobs);
    } catch (error) {
      console.error('Error loading jobs:', error);
    }
  };

  // ✅ Build email body
  const buildHtmlContent = () => {
    return `
      <h3>🧾 Latest Jobs from Kashmir Jobs</h3>
      <ul>
        ${jobs
          .map(
            (job) =>
              `<li><strong>${job.title}</strong> at ${job.company} — <a href="https://kashmirjobs.live/jobs/${job._id}">View Job</a></li>`
          )
          .join('')}
      </ul>
      <p>Visit <a href="https://kashmirjobs.live/jobs">kashmirjobs.live</a> for more updates.</p>
    `;
  };

  // ✅ Send Email
  const handleSend = async () => {
    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/admin/send-email`, {
        to: selectedEmails,
        subject: `📢 ${jobs.length} New Jobs from Kashmir Jobs`,
        html: buildHtmlContent(),
      });
      setStatus(`✅ Email sent to ${selectedEmails.length} users`);
    } catch (err) {
      setStatus('❌ Failed to send email');
    }
    setLoading(false);
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">📬 Send Job Alerts</h2>

      {/* Step 1: User Selection */}
      <div className="bg-white rounded shadow p-4 mb-4">
        <h3 className="text-lg font-semibold mb-2">1. Select Recipients</h3>
        <button onClick={selectAll} className="mr-2 text-blue-600">Select All</button>
        <button onClick={clearAll} className="text-red-600">Clear All</button>
        <ul className="max-h-40 overflow-y-auto border p-2 mt-2">
          {users.map((user) => (
            <li key={user.id}>
              <label>
                <input
                  type="checkbox"
                  checked={selectedEmails.includes(user.email)}
                  onChange={() => toggleEmail(user.email)}
                  className="mr-2"
                />
                {user.email}
              </label>
            </li>
          ))}
        </ul>
      </div>

      {/* Step 2: Job Filter */}
      <div className="bg-white rounded shadow p-4 mb-4">
        <h3 className="text-lg font-semibold mb-2">2. Choose Time Range</h3>
        <select
          value={days}
          onChange={(e) => setDays(e.target.value)}
          className="border rounded px-2 py-1"
        >
          <option value={1}>Last 1 Day</option>
          <option value={2}>Last 2 Days</option>
          <option value={3}>Last 3 Days</option>
          <option value={7}>Last 7 Days</option>
        </select>
        <button onClick={loadJobs} className="ml-4 bg-green-600 text-white px-3 py-1 rounded">
          Load Jobs
        </button>
      </div>

      {/* Step 3: Preview Email */}
      <div className="bg-white rounded shadow p-4 mb-4">
        <h3 className="text-lg font-semibold mb-2">3. Preview Email</h3>
        <div
          className="border p-3 bg-gray-50"
          dangerouslySetInnerHTML={{ __html: buildHtmlContent() }}
        />
      </div>

      {/* Step 4: Send Button */}
      <div className="text-center">
        <button
          onClick={handleSend}
          className="bg-blue-600 text-white px-6 py-2 rounded"
          disabled={loading || !selectedEmails.length || !jobs.length}
        >
          {loading ? 'Sending...' : '📩 Send Email'}
        </button>
        {status && <p className="mt-2">{status}</p>}
      </div>
    </div>
  );
};

export default SendAlerts;
